import {useAppSelector} from "./useAppSelector";

export const useContentLoading = () => {
    const loading = useAppSelector(state => state.translations.isLoading || state.changes.isLoading);
    return [loading];
}
